import styled from "styled-components"
export const Component = styled.div`
    width:100%;
    display:inline-block;
    margin-left:auto;
    // position:absolute;
`